import { render, staticRenderFns } from "./PatientSidebarNav.vue?vue&type=template&id=100db244&scoped=true&"
import script from "./PatientSidebarNav.vue?vue&type=script&lang=js&"
export * from "./PatientSidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./PatientSidebarNav.vue?vue&type=style&index=0&id=100db244&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100db244",
  null
  
)

export default component.exports